import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import "./Violation.css";

const STATIC_TRUCKS = [
  '2895DK','3734WB','867BA','5865BK','5439AK','247DK','8178DK','2578RH','5427AK','9305ML',
  '8269WB','1258MR','4451MS','2627RH','4947DK','5743HK','242BK','2674YM','154HK',
  '3757AK','1589WB','9011BA','7178HK','4412WA','4090DK','3658MS','6927YS','8563YS','8259DA','6386ML','7606WB',
  '5380BK','6641MS','1553YS','9537YW','2271MS','693HA','6655RA','8111MS','9192MB','4702MA','9637AK','8411YR',
  '371YM','9906MS','3381HW','4896BM','8784RA','113DS','3467DA','6820RA','6905MH','5524RH','1323MS','2691RA',
  '897BM','3270WA','4611ML','4425RA','8089RK','193RH','3883DA','2817ML','7684MH','7135RA','4427MR','7025MS',
  '980MH','4726MA','7745MR','7058MH','3218MS','1780YS','520BM','961MH','4093HK','277MS','9073HW','7378YR',
  '1804BA','6807MB','3710WK','4985YR','7103HA','4520HK','629YR','3255DK','6502MA','7330WK','8938YW','1771RA',
  '8524WK','1030DA','2557YM','5622BK','624RA','3847MK','4556MK','6678MA','4220ML','3526MB','5142MB','1550MK',
  '3167MD','1477MD','144RA','9299YW','50YM','899HM','2227WK','9299YM','8180BM', '9742RA', '2925WA', '7085HW',
  '1041HK','4501YM','5038YW','5956YW','1372HK','814HA','3777YW','9852BM','1324BK','795MB', '2913MB'
];

const normalizeTruckNo = (value) =>
  (value || "").toString().toUpperCase().replace(/[^A-Z0-9]/g, "");

const STATIC_TRUCK_LOOKUP = new Set(STATIC_TRUCKS.map(normalizeTruckNo));

const toLocalDateTimeInput = (value) => {
  if (!value) return "";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "";
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}T${String(date.getHours()).padStart(2, "0")}:${String(date.getMinutes()).padStart(2, "0")}`;
};

const EditDfmsTruckDefect = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [formData, setFormData] = useState(null);
  const [trucks, setTrucks] = useState([]);
  const [message, setMessage] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("token");

    const loadDefect = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BASE_API_URL}/dfms-truck-defects/${id}`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        const raw = response.data?.data || response.data || {};
        const normalized = {};
        Object.keys(raw || {}).forEach((key) => {
          normalized[key.toLowerCase()] = raw[key];
        });
        setFormData({
          journey_plane_no: normalized.journey_plane_no || "",
          scheduled_vehicle: normalized.scheduled_vehicle || "",
          driver_name: normalized.driver_name || "",
          driver_phone: normalized.driver_phone || "",
          carrier: normalized.carrier || "",
          ivms_point: normalized.ivms_point || "",
          defect_time: toLocalDateTimeInput(normalized.defect_time),
          remarks: normalized.remarks || "",
          source: normalized.source || "MANUAL",
          defect_status: normalized.defect_status || "OPEN",
          resolved: normalized.resolved || "N",
          resolution_remarks: normalized.resolution_remarks || "",
        });
      } catch (error) {
        console.error("Error loading DFMS defect:", error);
        setMessage("Failed to load DFMS defect.");
      }
    };

    const fetchInTransitTrucks = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BASE_API_URL}/inTransitTrucks`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        setTrucks(response.data || []);
      } catch (error) {
        console.error("Error fetching in-transit trucks:", error);
      }
    };

    loadDefect();
    fetchInTransitTrucks();
  }, [id]);

  const handleTruckChange = (e) => {
    const { name, value } = e.target;
    const selectedTruck = trucks.find(
      (truck) => truck.journey_plane_no === value || truck.scheduled_vehicle === value
    );

    if (selectedTruck) {
      setFormData((prev) => ({
        ...prev,
        journey_plane_no: selectedTruck.journey_plane_no,
        scheduled_vehicle: selectedTruck.scheduled_vehicle,
        driver_name: selectedTruck.driver_name || "",
        driver_phone: selectedTruck.driver_phone || "",
        carrier: selectedTruck.carrier || "",
        ivms_point: selectedTruck.ivms_point || "",
      }));
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
      ...(name === "defect_status"
        ? { resolved: value === "RESOLVED" ? "Y" : "N" }
        : {}),
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isSubmitting) return;

    const normalizedTruck = normalizeTruckNo(formData.scheduled_vehicle);
    if (!STATIC_TRUCK_LOOKUP.has(normalizedTruck)) {
      setMessage("Truck number does not match the Trip Registration static truck list.");
      return;
    }

    setIsSubmitting(true);
    try {
      const token = localStorage.getItem("token");
      await axios.put(
        `${process.env.REACT_APP_BASE_API_URL}/dfms-truck-defects/${id}`,
        {
          ...formData,
          scheduled_vehicle: normalizedTruck,
          defect_time: formData.defect_time ? new Date(formData.defect_time).toISOString() : null,
          resolved: formData.defect_status === "RESOLVED" ? "Y" : "N",
          date_resolved:
            formData.defect_status === "RESOLVED"
              ? new Date().toISOString()
              : null,
        },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setMessage("DFMS defect updated successfully.");
      setTimeout(() => navigate("/dfms-truck-defects"), 1200);
    } catch (error) {
      console.error("Error updating DFMS defect:", error);
      setMessage(error.response?.data?.message || "Failed to update DFMS defect.");
    } finally {
      setIsSubmitting(false);
    }
  };

  if (!formData) {
    return <div style={{ padding: "20px", textAlign: "center" }}>Loading...</div>;
  }

  return (
    <div className="container-add-violation">
      <button className="close-button" onClick={() => navigate("/dfms-truck-defects")}>x</button>
      <h2 className="violation-form-header">Edit DFMS Defect</h2>
      {message && <div className={`violation-message ${message.includes("successfully") ? "success" : "error"}`}>{message}</div>}

      <div className="violation-form-wrapper">
        <form onSubmit={handleSubmit}>
          <div className="violation-form-row">
            <div className="violation-form-group">
              <label>Journey / JP No</label>
              <input list="edit-dfms-journey-list" name="journey_plane_no" value={formData.journey_plane_no} onChange={handleTruckChange} />
              <datalist id="edit-dfms-journey-list">
                {trucks.map((truck) => <option key={`j-${truck.journey_plane_no}`} value={truck.journey_plane_no} />)}
              </datalist>
            </div>
            <div className="violation-form-group">
              <label>Truck Number *</label>
              <input list="edit-dfms-vehicle-list" name="scheduled_vehicle" value={formData.scheduled_vehicle} onChange={handleTruckChange} required />
              <datalist id="edit-dfms-vehicle-list">
                {trucks.map((truck) => <option key={`v-${truck.scheduled_vehicle}`} value={truck.scheduled_vehicle} />)}
              </datalist>
            </div>
          </div>

          <div className="violation-form-row">
            <div className="violation-form-group">
              <label>Driver Name</label>
              <input name="driver_name" value={formData.driver_name} onChange={handleChange} />
            </div>
            <div className="violation-form-group">
              <label>Driver Phone</label>
              <input name="driver_phone" value={formData.driver_phone} onChange={handleChange} />
            </div>
          </div>

          <div className="violation-form-row">
            <div className="violation-form-group">
              <label>Carrier</label>
              <input name="carrier" value={formData.carrier} onChange={handleChange} />
            </div>
            <div className="violation-form-group">
              <label>Last Check Point</label>
              <input name="ivms_point" value={formData.ivms_point} onChange={handleChange} />
            </div>
          </div>

          <div className="violation-form-row">
            <div className="violation-form-group">
              <label>Defect Time *</label>
              <input type="datetime-local" name="defect_time" value={formData.defect_time} onChange={handleChange} required />
            </div>
            <div className="violation-form-group">
              <label>Status</label>
              <select name="defect_status" value={formData.defect_status} onChange={handleChange}>
                <option value="OPEN">OPEN</option>
                <option value="RESOLVED">RESOLVED</option>
              </select>
            </div>
          </div>

          <div className="violation-form-row full">
            <div className="violation-form-group">
              <label>Remarks</label>
              <textarea name="remarks" value={formData.remarks} onChange={handleChange} />
            </div>
          </div>

          <div className="violation-form-row full">
            <div className="violation-form-group">
              <label>Resolution Remarks</label>
              <textarea name="resolution_remarks" value={formData.resolution_remarks} onChange={handleChange} />
            </div>
          </div>

          <div className="violation-form-actions">
            <button type="submit" className="submit" disabled={isSubmitting}>{isSubmitting ? "Saving..." : "Update DFMS Defect"}</button>
            <button type="button" className="cancel" onClick={() => navigate("/dfms-truck-defects")}>Cancel</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditDfmsTruckDefect;
